import { render, staticRenderFns } from "./SmartCaseStudy.vue?vue&type=template&id=221bcfec&scoped=true"
import script from "./SmartCaseStudy.vue?vue&type=script&lang=js"
export * from "./SmartCaseStudy.vue?vue&type=script&lang=js"
import style0 from "./SmartCaseStudy.vue?vue&type=style&index=0&id=221bcfec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221bcfec",
  null
  
)

export default component.exports